import { useContext } from 'react';
import { getDeployedProductId } from 'src/utils/generics';
import { IConfigState, IStoreState, IConfigSelectors } from 'src/@app/props';
import { appActionTypes } from 'src/@app/newActionTypes';
import { GlobalStateContext } from 'src/@app/providers/GlobalStateProvider';
import { useSelectors } from 'src/utils/storeHelpers';
import { parseQueryString } from 'src/utils/queryParams';
import { USER_SETTINGS } from 'src/constants';

export const useConfigSelectors: () => IConfigSelectors = () => {
  const state: IStoreState = useContext(GlobalStateContext);
  const configState: IConfigState = state.config;

  return useSelectors(configState, (state: IConfigState) => ({
    hasCompletedInitialLoad: () => state.initialLoadCompleted,
    getConfig: () => state.config,
    hasAccessFailed: () => state.failedToAccessConfig,
    getProductId: () => getDeployedProductId(),
    getTimeZone: () => {
      if (state.config && typeof state.config.globals !== 'undefined') {
        return state.config.globals.timeZone;
      }

      return 'UTC'; // Default is UTC/GMT
    },
    getAvailableRoutes: () => {
      if (state.config && typeof state.config.globals !== 'undefined') {
        return state.config.globals.availableRoutes;
      }

      return [];
    },
    getOperationFilterSet: () => {
      const savedSetName = parseQueryString(window.location.search).filter;
      const filterSet = savedSetName ? savedSetName : 'defaults';
      if (state.config) {
        const configSet = state.config.operations.filter[filterSet];
        return configSet ? configSet : state.config.operations.filter.defaults;
      }
      return {};
    },
    getIfPortraitLayout: () => state.userConfig.isPortrait,
  }));
};

export const configInitialState: IConfigState = {
  deployedProductId: getDeployedProductId(),
  config: null,
  failedToAccessConfig: false,
  initialLoadCompleted: false,
  userConfig: {
    isPortrait: true,
  },
};

export const configReducer = (state: IConfigState, action: any) => {
  switch (action.type) {
    case appActionTypes.UPDATE_USER_CONFIG:
      const newSettings = Object.assign({}, state.userConfig, action.payload);
      localStorage.setItem(USER_SETTINGS, JSON.stringify(newSettings));
      return Object.assign({}, state, {
        userConfig: newSettings,
      });
    case appActionTypes.UPDATE_CONFIG:
      let userSettings = {};
      const retrievedSettings = localStorage.getItem(USER_SETTINGS);
      if (retrievedSettings) {
        userSettings = JSON.parse(retrievedSettings);
      }

      return Object.assign({}, state, {
        config: action.payload,
        failedToAccessConfig: false,
        initialLoadCompleted: true,
        userConfig: Object.assign({}, state.userConfig, userSettings),
      });
    case appActionTypes.CONFIG_ERROR:
      return Object.assign({}, state, {
        config: null,
        failedToAccessConfig: true,
      });
    default:
      return state;
  }
};
